import { CoinsEffect } from '../../lib/classes/animation';
import { EffectsContainer } from '../../lib/components';
export function runCoinsEffect(coins, onDone) {
    var _a = getStartPos(), x = _a[0], y = _a[1];
    var _b = getTargetPos(), x2 = _b[0], y2 = _b[1];
    var coinsEffect = new CoinsEffect({ coins: coins, x: x, y: y, x2: x2, y2: y2 });
    new EffectsContainer({ effects: { coins: coinsEffect }, onDone: onDone });
}
function getStartPos() {
    var x = window.innerWidth / 2;
    var y = Math.min(350, window.innerHeight / 2);
    return [x, y];
}
function getTargetPos() {
    var storeBtn = document.querySelector('.TopPanel__storeBtn');
    if (storeBtn) {
        var _a = storeBtn.getBoundingClientRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        return [x + width / 2, y + height / 2];
    }
    var x0 = getStartPos()[0];
    return [x0, 30];
}
if (DEVELOPMENT) {
    // @ts-ignore
    window['runCoinsEffect'] = function () { return runCoinsEffect(100); };
}
